module.exports = "/assets/landing-rwx/instagram/insta-feed-4.jpg?DgHK7LZ";